var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUploadExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 10.875H11.5V6.5H12.75V11.5C12.75 11.8452 12.4702 12.125 12.125 12.125H0.875C0.529825 12.125 0.25 11.8452 0.25 11.5V6.5H1.5V10.875ZM7.125 4.625V9H5.875V4.625H2.75L6.5 0.875L10.25 4.625H7.125Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadExcel);
export default __webpack_public_path__ + "static/media/IconUploadExcel.4030c9d43ae80992e7a07e95c10348a2.svg";
export { ForwardRef as ReactComponent };